export const capitalizeFirstLetter = (code: string): string =>
    code.charAt(0).toUpperCase() + code.slice(1).toLocaleLowerCase()
